//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import structuredClone from '@ungap/structured-clone'

export default {
  components: {},
  data() {
    return {
      total_bets: 1,
      loading: false,
      calculating: false,
      freebetOptions: [],
      freebetCode: '',
    }
  },
  props: ['mini'],
  watch: {
    selections: function (newSelections, oldSelections) {
      console.log('betbuilder selections', _.size(newSelections), _.size(oldSelections))
    }
  },
  beforeDestroy() {
    console.log('beforeDestroy betbuilder_added');
    this.$root.$off('betbuilder_added');
    this.$root.$off('betbuilder_removed');
  },
  mounted() {
    this.$store.commit('betbuilder/setError', null)
    if(!this.processingStatus || this.processingStatus == 'completed') {
      this.processingStatus = null;
      this.$store.commit('betbuilder/setReceipt', null)
    }
    if (tock.active('betbuilder')) {
      tock.clear('betbuilder')
    }
    /*tock.setInterval(
      'betbuilder',
      () => {
        this.refreshOdds()
      },
      30 * 1000
    )*/
    console.log('mounted betbuilder_added');

    this.$root.$on('betbuilder_added', () => {
      console.log('betbuilder_added');
      this.calculating = true
      this.refreshOdds()
    })
    this.$root.$on('betbuilder_removed', () => {
      this.calculating = true
      this.refreshOdds()
    })

    this.fetchFreebets();
    this.$root.$on('update_freebets', () => {
      this.fetchFreebets()
    })

    if(_.size(this.selections)) {
      this.refreshOdds()
    }
  },
  computed: {
    error() {
      return this.$store.state.betbuilder.error
    },
    warning() {
      return this.$store.state.betbuilder.warning
    },
    precannedLoading() {
      return this.$store.state.betbuilder.precannedLoading
    },
    show_changed_odds_btn() {
      return false
    },
    can_place_bet() {
      if (this.stake <= 0  && !this.freebet) {
        return false
      }
      if (this.total_odds <= 1) {
        return false
      }
      if (this.total_stake <= 0) {
        if (_.get(this.freebet, 'amount_remaining') > 0) {
          return true
        }
        return false
      }
      return true
    },
    total_return() {
      let total_stake = this.stake;

      let freebet_stake = 0;
      let freebet_remaining = parseInt(_.get(this.freebet, 'amount_remaining')) / 100
      if (freebet_remaining) {
        total_stake = _.clone(freebet_remaining)
        freebet_stake = _.clone(freebet_remaining)
      }

      let total = total_stake * _.get(this.$store.state.betbuilder, 'ticket.display_odds.decimal')

      if (_.get(this.freebet, 'amount_remaining') > 0) {
        total = total - freebet_stake
      }
      return -Math.round(-total * 100) / 100
    },
    total_stake_display() {
      let total = _.get(this.$store.state.betbuilder, 'stake')
      if (_.get(this.freebet, 'amount_remaining')) {
        total = Math.max(0, total - _.get(this.freebet, 'amount_remaining') / 100)
        total = 0
      }
      return total
    },
    total_odds() {
      let oddsFormat = _.get(this.$store.state, 'settings.oddsFormat')
      return _.get(this.$store.state.betbuilder, 'ticket.display_odds.' + oddsFormat)
    },
    ticket() {
      return this.$store.state.betbuilder.ticket
    },    
    receipt() {
      return this.$store.state.betbuilder.receipt
    },
    selections() {
      return this.$store.state.betbuilder.selections
    },
    accept_odds() {
      return this.$store.state.settings.acceptOdds
    },
    showResults() {
      return this.processingStatus == 'completed'
      return false
    },
    stake: {
      get() {
        return this.$store.state.betbuilder.stake
      },
      set(value) {
        this.$store.commit('betbuilder/setStake', value)
      }
    },
    processingStatus: {
      get() {
        return this.$store.state.betbuilder.processingStatus
      },
      set(value) {
        this.$store.commit('betbuilder/setProcessingStatus', value)
      }
    },
    freebet_enabled() {
        /*if(!this.isTester) {
          return false;
        }*/

        if(this.freebetOptions && this.freebetOptions.length) {
          if(this.betType == 'system') {
            return false;
          }
          if(this.betType == 'single' && this.selections.length > 1) {
            return false;
          }
          if (this.betType == 'single' && this.selections.length == 1) {
            if(_.map(this.selections, 'outcome.is_each_way').filter(Boolean).length) return false;
          }
          if (this.betType == 'combi' && this.is_each_way) {
            return false;
          }
          return true;
        }

        return false;
    },
    freebet() {
      let freebet = _.find(this.freebetOptions, { id: parseInt(this.freebetCode) })
      if (freebet) return freebet
      return null
    },
  },
  methods: {
    async fetchFreebets() {
      if (!this.user) {
        this.freebetOptions = [];
        this.$store.commit('setFreebetCount', _.size(this.freebetOptions))
        return false
      }

      try {
        const response = await this.$api().get('api/content/freebets/active', { params: { active: true, bookmaker: process.env.BOOKMAKER } })
        this.freebetOptions = _.get(response.data, 'data', [])
        this.$store.commit('setFreebetCount', _.size(this.freebetOptions))
      } catch (e) {
        
      }
    },
    async openSettings() {
      this.$modal.show('modal-settings')
    },
    async clear() {
      this.$emit('clear');
      this.processingStatus = false
      //this.$store.commit('betbuilder/clear')
      //this.$store.commit('betbuilder/setError', null)
    },
    async close() {
      this.$emit('close');
      //this.$store.commit('betbuilder/toggleBetslip', false)
    },
    async closeResults() {
      this.processingStatus = false
    },
    async updateSelections() {},

    async refreshOdds() {
      console.log('refreshOdds', this.showBetBuilder)
      if (!this.showBetBuilder) {
        return
      }
      //get the selections, get the fixture id
      let params = {}
      params.selections = this.selections
      params.event_id = this.$store.state.betbuilder.eventId
      params.precanned_id = this.$store.state.betbuilder.precannedId
      params.bookmaker = this.$config.BOOKMAKER;
      params.lang = this.lang;
      params.country = this.country;

      console.log('params', params)
      this.cancelTokenSource = this.$axios.CancelToken.source()
      this.cancelTokenSource && this.cancelTokenSource.cancel('Operation canceled due to new request.');
      this.cancelTokenSource = this.$axios.CancelToken.source();

      const response = await this.$api().$post('/v1/betbuilder/calculate', params, {cancelToken: this.cancelTokenSource.token})

      if (response.ticket) {
        this.$store.commit('betbuilder/setSelections', _.get(response, 'ticket.selections'))
        this.$store.commit('betbuilder/setTicket', _.get(response, 'ticket'))
        if(_.size(_.get(response, 'ticket.selections')) > 1 && _.get(response, 'ticket.odds') == 0) {
          this.$store.commit('betbuilder/setWarning', this.$t("Some selections for this event can’t be combined. Please remove some selections to proceed."))
        } else {
          this.$store.commit('betbuilder/setWarning', null)
        }
      }
      this.calculating = false
      this.$store.commit('betbuilder/setPrecannedLoading', false)
      console.log('response', response)
    },
    async closeResults() {
      this.processingStatus = false
    },
    async placeBet() {
      if (!this.user) {
        this.openLogin()
        return
      }

      this.$store.commit('betbuilder/setError', null)
      //get the selections, get the fixture id
      let params = {}
      params.selections = this.selections
      params.event_id = this.$store.state.betbuilder.eventId
      params.stake = this.stake
      params.current_odds = this.total_odds
      params.accept_odds = _.get({ all: 'ACCEPT_ANY', higher: 'ACCEPT_HIGHER', none: 'ACCEPT_NONE' }, _.get(this.$store.state, 'settings.acceptOdds'))
      params.bookmaker = this.$config.BOOKMAKER
      params.lang = this.lang;
      params.country = this.country;
      params.freebet = _.get(this.freebet, 'id');
      this.loading = true;
      console.log('params', params)
      
      try {
        this.processingStatus = 'processing'
        const response = await this.$api().$post('/v1/betbuilder/submit', params)
        console.log('response', response)
        if (_.get(response, 'status') == true) {
          //if ok show receipt
          this.$store.commit('betbuilder/setReceipt', _.get(response, 'receipt'))

          /*this.receipt = _.get(response, 'receipt')
          console.log('this.receipt', this.receipt)
          console.log('this.receipt', response)*/
          this.processingStatus = 'completed';
          
          this.$root.$emit('update_balance')
          //
        } else {
          //show error message
            this.$store.commit('betbuilder/setError', _.get(e.response, 'data.message'))
        }
        this.loading = false;
        this.freebetCode = ''
      } catch(e) {
        console.log('placeBet', _.get(e.response, 'data.message'))
        this.$store.commit('betbuilder/setError', _.get(e.response, 'data.message'))
        this.loading = false;
      }

      this.fetchFreebets()
      this.$root.$emit('update_freebets')

      const elements = document.querySelectorAll('.precanned-btn');
      
      elements.forEach(element => {
        const isSelected = element.classList.contains('selected');
        
        if (isSelected) {
          element.classList.remove('bg-primary-500', 'text-white');
          element.classList.add('bg-gray-600', 'text-primary-500');
          element.classList.remove('selected');
        }
      });
    }
  }
}
